var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('CardSection',{attrs:{"sortable":true,"title-icon":_vm.$globals.icons.user,"title":_vm.userData.username,"recipes":_vm.shownRecipes},on:{"sort":_vm.assignSorted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }